import type { SVGProps } from "react";

export default function RefreshIcon({
  width = 14,
  height = 14,
  ...rest
}: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        d="M3.065 10.8333L2.6248 11.277C2.86848 11.5187 3.26153 11.5187 3.5052 11.277L3.065 10.8333ZM4.90505 9.88808C5.15008 9.645 5.15163 9.24925 4.90852 9.00425C4.6654 8.75917 4.26968 8.75767 4.02464 9.00075L4.90505 9.88808ZM2.10536 9.00075C1.86033 8.75767 1.4646 8.75917 1.22148 9.00425C0.978368 9.24925 0.979926 9.645 1.22496 9.88808L2.10536 9.00075ZM15.5115 6.16066C15.6922 6.45471 16.0772 6.54654 16.3712 6.36577C16.6652 6.18499 16.7571 5.80006 16.5763 5.50601L15.5115 6.16066ZM10.0642 1.875C5.85812 1.875 2.44 5.25933 2.44 9.44442H3.69C3.69 5.95893 6.53919 3.125 10.0642 3.125V1.875ZM2.44 9.44442V10.8333H3.69V9.44442H2.44ZM3.5052 11.277L4.90505 9.88808L4.02464 9.00075L2.6248 10.3897L3.5052 11.277ZM3.5052 10.3897L2.10536 9.00075L1.22496 9.88808L2.6248 11.277L3.5052 10.3897ZM16.5763 5.50601C15.2377 3.32856 12.8212 1.875 10.0642 1.875V3.125C12.3722 3.125 14.3924 4.34037 15.5115 6.16066L16.5763 5.50601Z"
        fill="currentColor"
      />
      <path
        d="M16.927 9.1665L17.3664 8.722C17.123 8.48134 16.7311 8.48134 16.4877 8.722L16.927 9.1665ZM15.0825 10.1109C14.837 10.3535 14.8347 10.7493 15.0773 10.9948C15.32 11.2403 15.7157 11.2426 15.9612 10.9999L15.0825 10.1109ZM17.8929 10.9999C18.1384 11.2426 18.5341 11.2403 18.7767 10.9948C19.0194 10.7493 19.0171 10.3535 18.7716 10.1108L17.8929 10.9999ZM4.4304 13.8383C4.24912 13.5445 3.86403 13.4533 3.57029 13.6347C3.27654 13.8159 3.18538 14.201 3.36665 14.4948L4.4304 13.8383ZM9.90104 18.1248C14.1197 18.1248 17.552 14.7428 17.552 10.5554H16.302C16.302 14.0387 13.4431 16.8748 9.90104 16.8748V18.1248ZM17.552 10.5554V9.1665H16.302V10.5554H17.552ZM16.4877 8.722L15.0825 10.1109L15.9612 10.9999L17.3664 9.611L16.4877 8.722ZM16.4877 9.611L17.8929 10.9999L18.7716 10.1108L17.3664 8.722L16.4877 9.611ZM3.36665 14.4948C4.71049 16.6723 7.13548 18.1248 9.90104 18.1248V16.8748C7.58231 16.8748 5.55365 15.6584 4.4304 13.8383L3.36665 14.4948Z"
        fill="currentColor"
      />
    </svg>
  );
}
